import prefixEve from 'src/utils/routeFilter.js'
const prefix = prefixEve.cuttingFiler()

// 注意：
// 1. 每个一级菜单一个顶层路由对象（name 唯一），component 复用 home.vue；侧边栏分组标题由一级菜单 meta.group 提供；
// 2. 简单模块列表页 path 加一层（/list、/index）；已有层级（apps/system）与 tabs 外壳保持原 URL；
// 3. 详情页去掉 :id 动态参数，改由 query 传 id（/customers/detail/base?id=xxx）；
// 4. meta.icon 使用 iconfont class（src/styles/font_5237464_51of7hpp79e，以 icon- 开头）。
// 5. rouKey: 只能手动增加和修改，切记。
// boss 端 = 运营管理后台
export const bossRoutes = [
  // ===== 运营仪表盘 =====
  {
    path: prefix + '/dashboard',
    name: 'BossLayoutDashboard',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/dashboard/index`,
    meta: { hidden: true },
    children: [
      {
        path: 'index',
        name: 'BossDashboard',
        component: () => import('@/views/boss/dashboard/index.vue'),
        meta: { title: '运营仪表盘', icon: 'icon-shouye', group: '总览' },
        rouKey: 'boss.index'
      }
    ]
  },
  // ===== 企业管理 =====
  {
    path: prefix + '/customers',
    name: 'BossLayoutCustomers',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/customers/list`,
    meta: { hidden: true },
    children: [
      {
        path: 'list',
        name: 'BossCustomers',
        component: () => import('@/views/boss/customers/index.vue'),
        meta: {
          title: '企业管理',
          icon: 'icon-yonghu',
          group: '租户',
          keepAlive: true
        },
        rouKey: 'boss.ent'
      },
      // 新增企业（独立页面，不进侧边栏；activeMenu 保持「企业管理」高亮）
      {
        path: 'create',
        name: 'BossCustomerCreate',
        component: () => import('@/views/boss/customers/create.vue'),
        meta: { title: '企业管理/新增企业', hidden: true, activeMenu: prefix + '/customers/list', cacheParent: 'BossCustomers' },
      },
      // 企业详情（tabs 外壳 + 四个嵌套子页，不进侧边栏；activeMenu 保持「企业管理」高亮）
      {
        path: 'detail',
        name: 'BossCustomerDetail',
        component: () => import('@/views/boss/customers/DetailPage.vue'),
        redirect: { name: 'BossCustomerDetailBase' },
        meta: { title: '企业管理/企业详情', hidden: true, activeMenu: prefix + '/customers/list', cacheParent: 'BossCustomers' },
        children: [
          {
            path: 'base',
            name: 'BossCustomerDetailBase',
            component: () => import('@/views/boss/customers/detail/BasePage.vue'),
            meta: { title: '企业管理/基础信息', hidden: true },
          },
          {
            path: 'packages',
            name: 'BossCustomerDetailPackages',
            component: () => import('@/views/boss/customers/detail/PackagesPage.vue'),
            meta: { title: '企业管理/积分余额', hidden: true },
          },
          {
            path: 'usage',
            name: 'BossCustomerDetailUsage',
            component: () => import('@/views/boss/customers/detail/UsagePage.vue'),
            meta: { title: '企业管理/积分消耗', hidden: true },
          },
          {
            path: 'logs',
            name: 'BossCustomerDetailLogs',
            component: () => import('@/views/boss/customers/detail/LogsPage.vue'),
            // keepQuery：面包屑「日志详情」层级点「操作日志」回跳时保留企业 id
            meta: { title: '企业管理/操作日志', hidden: true, keepQuery: ['id'] },
          },
          {
            path: 'auth',
            name: 'BossCustomerDetailAuth',
            component: () => import('@/views/boss/customers/detail/AuthPage.vue'),
            meta: { title: '企业管理/应用授权', hidden: true },
          }
        ]
      },
      // 操作日志详情（独立页面，不进详情 tabs 外壳；activeMenu 保持「企业管理」高亮）
      {
        path: 'logs/detail',
        name: 'BossCustomerLogDetail',
        component: () => import('@/views/boss/customers/detail/LogDetailPage.vue'),
        meta: { title: '企业管理/操作日志/日志详情', hidden: true, activeMenu: prefix + '/customers/list', cacheParent: 'BossCustomers' },
      }
    ]
  },
  // ===== 储值管理 =====
  {
    path: prefix + '/topup',
    name: 'BossLayoutTopup',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/topup/list`,
    meta: { hidden: true },
    children: [
      {
        path: 'list',
        name: 'BossTopup',
        component: () => import('@/views/boss/topup/index.vue'),
        meta: {
          title: '储值管理',
          icon: 'icon-chuzhiqia',
          group: '财务',
          keepAlive: true
        },
        rouKey: 'boss.billing.recharge'
      },
      // 积分录入 / 编辑（二级页，不进侧边栏；activeMenu 保持「储值管理」高亮）
      {
        path: 'entry',
        name: 'BossTopupEntry',
        component: () => import('@/views/boss/topup/pointsEntry.vue'),
        meta: { title: '储值管理/新增储值', hidden: true, activeMenu: prefix + '/topup/list', cacheParent: 'BossTopup' },
      },
      // 储值流水详情（独立页，不进侧边栏；id 走 query）
      {
        path: 'detail',
        name: 'BossTopupDetail',
        component: () => import('@/views/boss/topup/detail.vue'),
        meta: { title: '储值管理/储值详情', hidden: true, activeMenu: prefix + '/topup/list', cacheParent: 'BossTopup' },
      }
    ]
  },
  // ===== 退款管理 =====
  {
    path: prefix + '/refund',
    name: 'BossLayoutRefund',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/refund/list`,
    meta: { hidden: true },
    children: [
      {
        path: 'list',
        name: 'BossRefund',
        component: () => import('@/views/boss/refund/index.vue'),
        meta: {
          title: '退款管理',
          icon: 'icon-tuikuan',
          group: '财务',
          keepAlive: true
        },
        rouKey: 'boss.billing.refund'
      },
      // 新增退款（独立页面，不进侧边栏；activeMenu 保持「退款管理」高亮）
      {
        path: 'create',
        name: 'BossRefundCreate',
        component: () => import('@/views/boss/refund/create.vue'),
        meta: { title: '退款管理/新增退款', hidden: true, activeMenu: prefix + '/refund/list', cacheParent: 'BossRefund' },
      },
      // 退款详情（独立页面，不进侧边栏；activeMenu 保持「退款管理」高亮；id 走 query）
      {
        path: 'detail',
        name: 'BossRefundDetail',
        component: () => import('@/views/boss/refund/detail.vue'),
        meta: { title: '退款管理/退款详情', hidden: true, activeMenu: prefix + '/refund/list', cacheParent: 'BossRefund' },
      }
    ]
  },
  // ===== 在线支付流水 =====
  {
    path: prefix + '/payflow',
    name: 'BossLayoutPayflow',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/payflow/list`,
    meta: { hidden: true },
    children: [
      {
        path: 'list',
        name: 'BossPayflow',
        component: () => import('@/views/boss/payflow/index.vue'),
        meta: { title: '在线支付流水', icon: 'icon-zaixianzhifu', group: '财务', keepAlive: true },
        rouKey: 'boss.billing.recharge.online'
      },
      // 在线支付详情（独立页，不进侧边栏；id 走 query，值为 recharge_id）
      {
        path: 'detail',
        name: 'BossPayflowDetail',
        component: () => import('@/views/boss/payflow/detail.vue'),
        meta: { title: '在线支付流水/在线支付详情', hidden: true, activeMenu: prefix + '/payflow/list', cacheParent: 'BossPayflow' },
      }
    ]
  },
  // ===== 积分消耗 =====
  {
    path: prefix + '/points',
    name: 'BossLayoutPoints',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/points/list`,
    meta: { hidden: true },
    children: [
      {
        path: 'list',
        name: 'BossPoints',
        component: () => import('@/views/boss/points/index.vue'),
        meta: { title: '积分消耗', icon: 'icon-jifen', group: '计费', keepAlive: true },
        rouKey: 'boss.billing.deduct'
      },
      // 消耗详情（独立页面，不进侧边栏；activeMenu 保持「积分消耗」高亮；id 走 query）
      {
        path: 'detail',
        name: 'BossPointsDetail',
        component: () => import('@/views/boss/points/detail/index.vue'),
        meta: { title: '积分消耗/消耗详情', hidden: true, activeMenu: prefix + '/points/list', cacheParent: 'BossPoints' },
      }
    ]
  },
  // ===== 应用管理（旧路径 /apps 兼容重定向） =====
  {
    path: prefix + '/apps',
    name: 'BossLayoutApps',
    redirect: `${prefix}/apps/manage`,
    meta: { hidden: true },
  },
  // ===== 应用管理 =====
  {
    path: prefix + '/apps/manage',
    name: 'BossLayoutAppsManage',
    component: () => import('@/views/home.vue'),
    meta: { hidden: true },
    children: [
      {
        path: '',
        name: 'BossAppsManage',
        component: () => import('@/views/boss/apps/manage/index.vue'),
        meta: {
          title: '应用管理',
          icon: 'icon-yingyongchengxu-xianxing',
          group: '应用与授权',
          keepAlive: true
        },
        rouKey: 'boss.app'
      },
      // 新增应用（独立页面，不进侧边栏；activeMenu 保持「应用管理」高亮）
      {
        path: 'create',
        name: 'BossAppCreate',
        component: () => import('@/views/boss/apps/create/index.vue'),
        meta: { title: '应用管理/新增应用', hidden: true, permHidden: true, activeMenu: prefix + '/apps/manage', cacheParent: 'BossAppsManage' },
      },
      // 编辑应用（与新增应用共用表单组件；id 走 query）
      {
        path: 'edit',
        name: 'BossAppEdit',
        component: () => import('@/views/boss/apps/create/index.vue'),
        meta: { title: '应用管理/编辑应用', hidden: true, permHidden: true, activeMenu: prefix + '/apps/manage', cacheParent: 'BossAppsManage' },
      },
      // 应用详情（独立展示页；id 走 query）
      {
        path: 'detail',
        name: 'BossAppDetail',
        component: () => import('@/views/boss/apps/manage/detail/index.vue'),
        meta: { title: '应用管理/应用详情', hidden: true, permHidden: true, activeMenu: prefix + '/apps/manage', cacheParent: 'BossAppsManage' },
      },
      // 企业授权（独立页面，不进侧边栏；应用 id 走 query）
      {
        path: 'ent-auths',
        name: 'BossAppEntAuths',
        component: () => import('@/views/boss/apps/manage/ent-auths/index.vue'),
        meta: { title: '应用管理/企业授权', hidden: true, permHidden: true, activeMenu: prefix + '/apps/manage', cacheParent: 'BossAppsManage' },
      }
    ]
  },
  // ===== 企业应用授权 =====
  {
    path: prefix + '/apps/grants',
    name: 'BossLayoutAppsGrants',
    component: () => import('@/views/home.vue'),
    meta: { hidden: true },
    children: [
      {
        path: '',
        name: 'BossAppsGrants',
        component: () => import('@/views/boss/apps/grants/index.vue'),
        meta: {
          title: '企业应用授权',
          icon: 'icon-miyuefuwu',
          group: '应用与授权',
          keepAlive: true
        },
        rouKey: 'boss.app.auth'
      },
      // 管理应用授权（独立页面，不进侧边栏；activeMenu 保持「企业应用授权」高亮；企业 id 走 query）
      {
        path: 'edit',
        name: 'BossAppGrantsEdit',
        component: () => import('@/views/boss/apps/grants/edit/index.vue'),
        meta: { title: '企业应用授权/管理应用授权', hidden: true, activeMenu: prefix + '/apps/grants', cacheParent: 'BossAppsGrants' },
      }
    ]
  },
  // ===== 服务商管理 =====
  {
    path: prefix + '/providers',
    name: 'BossLayoutProviders',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/providers/list`,
    meta: { hidden: true },
    children: [
      {
        path: 'list',
        name: 'BossProviders',
        component: () => import('@/views/boss/providers/index.vue'),
        meta: {
          title: '服务商管理',
          icon: 'icon-fuwushangguanli',
          group: '系统'
        },
        rouKey: 'boss.agent'
      }
    ]
  },
  // ===== 模型计费配置 =====
  {
    path: prefix + '/pricing',
    name: 'BossLayoutPricing',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/pricing/list`,
    meta: { hidden: true },
    children: [
      {
        path: 'list',
        name: 'BossPricing',
        component: () => import('@/views/boss/pricing/index.vue'),
        meta: {
          title: '模型计费配置',
          icon: 'icon-money-cylinder-o',
          group: '系统',
          keepAlive: true
        },
        rouKey: 'boss.model'
      },
      // 编辑费率（独立页面，不进侧边栏；activeMenu 保持「模型计费配置」高亮；id 走 query）
      {
        path: 'edit',
        name: 'BossPricingEdit',
        component: () => import('@/views/boss/pricing/edit/index.vue'),
        meta: { title: '模型计费配置/编辑费率', hidden: true, activeMenu: prefix + '/pricing/list', cacheParent: 'BossPricing' },
      }
    ]
  },
  // ===== 能力计费配置 =====
  {
    path: prefix + '/cap-pricing',
    name: 'BossLayoutCapPricing',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/cap-pricing/list`,
    meta: { hidden: true },
    children: [
      {
        path: 'list',
        name: 'BossCapPricing',
        component: () => import('@/views/boss/capPricing/index.vue'),
        meta: {
          title: '能力计费配置',
          icon: 'icon-gongxiangwangluojieru',
          group: '系统',
          keepAlive: true
        },
        rouKey: 'boss.capability'
      },
      // 编辑能力计费（独立页面，不进侧边栏；activeMenu 保持「能力计费配置」高亮；id 走 query）
      {
        path: 'edit',
        name: 'BossCapPricingEdit',
        component: () => import('@/views/boss/capPricing/edit/index.vue'),
        meta: { title: '能力计费配置/编辑能力计费', hidden: true, activeMenu: prefix + '/cap-pricing/list', cacheParent: 'BossCapPricing' },
      }
    ]
  },
  // ===== 操作日志（单页，不再区分运营后台/企业后台子路由） =====
  {
    path: prefix + '/logs',
    name: 'BossLayoutLogs',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/logs`,
    meta: { hidden: true },
    children: [
      {
        path: '',
        name: 'BossLogs',
        component: () => import('@/views/boss/logs/index.vue'),
        meta: { title: '操作日志', icon: 'icon-shiyongliang', group: '系统', keepAlive: true },
        rouKey: 'boss.log'
      },
      // 日志详情（复用企业管理日志详情页组件，独立页面不弹框；activeMenu 保持「操作日志」高亮）
      {
        path: 'detail',
        name: 'BossLogDetail',
        component: () => import('@/views/boss/customers/detail/LogDetailPage.vue'),
        meta: { title: '操作日志/日志详情', hidden: true, activeMenu: `${prefix}/logs`, cacheParent: 'BossLogs' },
      }
    ]
  },
  // ===== 个人信息（右上角头像菜单进入，不进侧边栏） =====
  {
    path: prefix + '/profile',
    name: 'BossLayoutProfile',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/profile`,
    meta: { hidden: true },
    children: [
      {
        path: '',
        name: 'BossProfile',
        component: () => import('@/views/boss/profile/index.vue'),
        meta: { title: '个人信息', hidden: true },
      }
    ]
  },
  // ===== 系统管理（tabs 外壳 + 角色/职工两个子页，子页 hidden 不进侧边栏） =====
  {
    path: prefix + '/system',
    name: 'BossLayoutSystem',
    component: () => import('@/views/home.vue'),
    redirect: `${prefix}/system/staff`,
    meta: { hidden: true },
    children: [
      {
        path: '',
        name: 'BossSystem',
        component: () => import('@/views/boss/system/index.vue'),
        redirect: `${prefix}/system/roles`,
        meta: { title: '系统管理', icon: 'icon-xitongguanli', group: '系统' },
        children: [
          {
            path: 'roles',
            name: 'BossSystemRoles',
            component: () => import('@/views/boss/system/roles/index.vue'),
            meta: {
              title: '角色管理',
              hidden: true
            },
            rouKey: 'boss.role'
          },
          {
            path: 'staff',
            name: 'BossSystemStaff',
            component: () => import('@/views/boss/system/staff/index.vue'),
            meta: {
              title: '职工管理',
              hidden: true
            },
            rouKey: 'boss.user'
          }
        ]
      }
    ]
  }
]

export default bossRoutes
